import { Trophy } from "lucide-react";
import { Nominee } from "../types";
import TrophyVehicleCard from "./TrophyVehicleCard";

const NomineeGroup = ({
  title,
  vehicles,
}: {
  title: string;
  vehicles: Nominee[];
}) => {
  return (
    <div className="noms-group">
      <div className="noms-title">
        <span className="ico">
          <Trophy aria-hidden="true" />
        </span>
        {title}
      </div>
      <div className="cards">
        {vehicles.map((vehicle) => (
          <TrophyVehicleCard key={vehicle.slug} vehicle={vehicle} />
        ))}
      </div>
    </div>
  );
};

const NomineesSection = ({
  citadines,
  familiales,
}: {
  citadines: Nominee[];
  familiales: Nominee[];
}) => {
  return (
    <section className="block nominees-section">
      <div className="wrap">
        <div className="section-head">
          <h2>
            Les <span className="accent">nominés</span>
          </h2>
        </div>
        <NomineeGroup title="Les citadines" vehicles={citadines} />
        <NomineeGroup title="Les familiales" vehicles={familiales} />
      </div>
    </section>
  );
};

export default NomineesSection;
